import React from "react";
import { useTable } from "react-table";
import Image from "next/image";
import Button from "components/FormElements/Button";
import { useGlobalStore } from "store/GlobalStore";
import { useAuthStore } from "store/AuthStore";

import { changeCurrency } from "helpers/helpersFunc";
import { useTranslation } from "next-i18next";
import { useConfigurationStore } from "../../store/ConfigurationStore";

function SSLTable({ datas, onAddBasket }) {
  const { t } = useTranslation(["header", "nav", "ssl"]);
  const [setDefaultPaymentCycle] = useConfigurationStore((((state) => [state.setSelectedServer])));
  const [isLoggin] = useAuthStore(((state) => [state.isLoggin]));

  const [currencyType, currencyRates] = useGlobalStore((state) => [state.currencyType, state.currencyRates]);
  const data = React.useMemo(
    () => {
      if (datas[0]?.one_month_price > 0) {
        setDefaultPaymentCycle(1);
      } else if (datas[0]?.three_month_price > 0) {
        setDefaultPaymentCycle(3);
      } else if (datas[0]?.six_month_price > 0) {
        setDefaultPaymentCycle(6);
      } else if (datas[0]?.one_year_price > 0) {
        setDefaultPaymentCycle(12);
      } else if (datas[0]?.two_year_price > 0) {
        setDefaultPaymentCycle(24);
      } else if (datas[0]?.three_year_price > 0) {
        setDefaultPaymentCycle(36);
      }

      return datas;
    }

    , []
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "col1", // accessor is the "key" in the data
        Cell: logo
      },
      {
        Header: t("ssl:certificateName"),
        accessor: "component"

      },
      {
        Header: t("ssl:encryption"),
        accessor: "col3",
        Cell: () => {
          return "128/256 Bit";
        }
      },
      {
        Header: t("ssl:freeInstallation"),
        accessor: "col4",
        Cell: thick

      },
      {
        Header: t("common:period"),
        accessor: "col5",
        Cell: () => {
          return "1 " + t("common:year");
        }

      },
      {
        Header: t("common:price"),
        accessor: "price",
        Cell: tablePrice

      },
      {
        Header: "",
        accessor: "col7",
        Cell: tableButton

      }
    ],
    [currencyType, isLoggin]
  );

  function logo(props) {
    let SplitedName = props.cell.row.original.component.split(" ");
    if (SplitedName[0] === "RapidSSL") {
      return <Image src="/RapidSSL.png" alt="rapid-ssl" title="Rapid SSL" width="86" height="22" quality={100}/>;
    } else if (SplitedName[0] === "Sectigo") {
      return <Image src="/sectigo.png"  width="107" height="20" alt="sectigo" title="Sectigo" quality={100}/>;
    } else if (SplitedName[0] === "GeoTrust") {
      return <Image src="/geoTrust.png" width="112" height="20" alt="geotrust" title="Geotrust" quality={100}/>;
    }else if (SplitedName[0] === "GoGetSSL") {
      return <Image src="/goGetSSL.svg" width="104" height="32" alt="GoGetSSL" title="GoGetSSL" quality={100}/>;
    }  else {
      return <Image src="/newSSL.png" width="104" height="28" alt="newssl" title="SSL" quality={100}/>;
    }
  }

  function thick(props) {
    // if (props.value === true) {
    //     return <svg className="mx-auto" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM8.25225 12L13.5548 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z" fill="#45D85B" />
    //     </svg>
    // }
    // else if (props.value === false) {
    //     return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M9 16.5C4.85775 16.5 1.5 13.1422 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1422 13.1422 16.5 9 16.5ZM9 7.9395L6.879 5.81775L5.81775 6.879L7.9395 9L5.81775 11.121L6.879 12.1823L9 10.0605L11.121 12.1823L12.1823 11.121L10.0605 9L12.1823 6.879L11.121 5.81775L9 7.9395Z" fill="#FF433D" />
    //     </svg>

    // } else {
    //     return props.value
    // }

    return <svg className="mx-auto" width="18" height="18" viewBox="0 0 18 18" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM8.25225 12L13.5548 6.69675L12.4943 5.63625L8.25225 9.879L6.1305 7.75725L5.07 8.81775L8.25225 12Z"
        fill="#45D85B" />
    </svg>;

  }

  function tablePrice(props) {
    let newPrice = changeCurrency(currencyRates, currencyType, props?.value.one_year, props.row.original?.currency);
    let splitedPrice = newPrice.split(".");
    if (props) {
      return (
        <div className="footerPrice">
          {/* <span className="line-through text-textGray">{props.value.oldPrice} ₺</span> */}
          <div className="flex">
            <p className="text-3xl font-medium text-titleColor">{splitedPrice[0]}.</p>
            <div className="flex flex-col ml-1">
              <span className="p-0 m-0 text-sm text-titleColor">{splitedPrice[1]} {currencyType}</span>
              <span className="p-0 m-0 text-sm text-titleColor">{t("common:yearly")}</span>
            </div>
          </div>
        </div>
      );

    }
  }

  function tableButton(props) {
    return <Button onClick={() => onAddBasket(props.cell.row.original)} name={props.cell.row.id}
      buttonText={t("common:addBasket")} buttonLeftIcon="ri-add-fill" />;


  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({ columns, data });

  return (
    <table {...getTableProps()} className="w-full">
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps()}
                className="p-3 text-sm text-left whitespace-nowrap bg-makdosTitleDiv text-textWhite"
              >
                {column.render("Header")}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, index) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} className={index % 2 === 0 ? " bg-white p-3" : " bg-makdosSecondaryGray p-3"}>
              {row.cells.map(cell => {
                return (
                  <td {...cell.getCellProps()} className="p-3 whitespace-nowrap">
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default SSLTable;
